import styled from 'styled-components';

const FormHeader = styled.h3`
   color: ${({ theme }) => theme.primaryBlueDark};
   font-size: 1.7em;
   font-weight: 700;
   letter-spacing: 1.2;
   display: block;
   margin: 10px auto 2em auto;
`;

export default FormHeader;
